import { axios, CancelTokenSource } from '../axios';
import {baseEnvironment} from '../environment/environment.base';

const sendConsentRoute = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.sendConsent}`
const sendToUsmonRoute = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.sendToUsmon}`
const sendDocUploadRoute = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.sendDocUpload}`
const updateNotificationRoute = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.updateNotificationPhone}`
const getPatientDoc = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.patientDocuments}`
const getPatientDocIds = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.patientIds}`
const getAdminDoc = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.adminDocuments}`
const getAdminDocIds = `${baseEnvironment.apiVersion1}/${baseEnvironment.apiEndPoints.patientDocumentUpload.adminIds}`

export const sendConsent = async (patientId: number,allowDuplicate: boolean): Promise<any> => {
    const response = await axios.get(`${sendConsentRoute}/${patientId}?allow_duplicate=${allowDuplicate}`)
    return response.data;
}

export const sendToUsmon = async (patientId: number): Promise<any> => {
    const response = await axios.get(`${sendToUsmonRoute}/${patientId}`)
    return response.data;
}

export const sendDocUpload = async (patientId: number): Promise<any> => {
    const response = await axios.get(`${sendDocUploadRoute}/${patientId}`)
    return response.data;
}

export const updateNotificationPhone = async (patientId: number, phone: string): Promise<any> => {
    const response = await axios.post(`${updateNotificationRoute}`, {patient_id:patientId,phone_number:phone});
    return response.data;
}
export const getAllPatients = async (
    offSet: number,
    searchText?: string,
    consentFilter?: string,
    smsFilter?: string,
    docUploadFilter?: string,
    sentToUsmonFilter?: string,
    cancelToken?: CancelTokenSource['token']
): Promise<any> => {
    try {
        let params = `?offset=${offSet}`;
        const searchParams = searchText ? `&search_text=${encodeURIComponent(searchText)}` : '';
        const consentParams = consentFilter? `&consent_status=${consentFilter}` : '';
        const smsParams = smsFilter? `&sms_status=${smsFilter}` : '';
        const docUploadParams = docUploadFilter? `&doc_upload=${docUploadFilter}` : '';
        const sentToUsmonParams = sentToUsmonFilter? `&sent_to_usmon=${sentToUsmonFilter}` : '';
        params = params + searchParams +consentParams+smsParams +docUploadParams+sentToUsmonParams
        const response = await axios.get(`${baseEnvironment.apiVersion1}/patient/all${params}`,{cancelToken});
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getDocumentsId = async(patientId: number): Promise<any> =>{
    const url = getPatientDocIds.replace(':patientId',String(patientId));
    const response = await axios.get(url);
    return response.data;
}

export const getDocuments = async (patientId: number,documentId:number): Promise<any> => {
    const url = getPatientDoc.replace(':patientId',String(patientId)).replace(':documentId',String(documentId));
    const response = await axios.get(url,{
        timeout:180000
    })
    return response.data;
}

export const getDocumentsIdForAdminPortal = async(patientId: number) : Promise<any> => {
    const url = getAdminDocIds.replace(':patientId',String(patientId));
    const response = await axios.get(url);
    return response.data;
}

export const getDocumentAdmin = async (patientId: number,documentId:number): Promise<any> => {
    const url = getAdminDoc.replace(':patientId',String(patientId)).replace(':documentId',String(documentId));
    const response = await axios.get(url,{
        timeout:180000
    })
    return response.data;
}